
import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { PageLoading } from "@/components/shared/PageLoading";

// Lazy loaded pages
const ClientDashboard = lazy(() => import("@/pages/portal/client/ClientDashboard"));
const ClientAppointments = lazy(() => import("@/pages/portal/client/ClientAppointments"));
const ClientProfile = lazy(() => import("@/pages/portal/client/ClientProfile"));
const ClientMessaging = lazy(() => import("@/pages/portal/messaging/ClientMessaging"));
const FindTherapistAI = lazy(() => import("@/pages/portal/client/FindTherapistAI"));
const SessionPrepare = lazy(() => import("@/pages/portal/client/SessionPrepare"));
const VideoSession = lazy(() => import("@/pages/portal/client/VideoSession"));

const ClientPortalRoutes = () => {
  return (
    <Routes>
      <Route path="/client-portal" element={
        <Suspense fallback={<PageLoading />}>
          <ClientDashboard />
        </Suspense>
      } />
      
      <Route path="/client-portal/appointments" element={
        <Suspense fallback={<PageLoading />}>
          <ClientAppointments />
        </Suspense>
      } />
      
      <Route path="/client-portal/profile" element={
        <Suspense fallback={<PageLoading />}>
          <ClientProfile />
        </Suspense>
      } />
      
      <Route path="/client-portal/messages" element={
        <Suspense fallback={<PageLoading />}>
          <ClientMessaging />
        </Suspense>
      } />
      
      <Route path="/client-portal/find-therapist-ai" element={
        <Suspense fallback={<PageLoading />}>
          <FindTherapistAI />
        </Suspense>
      } />
      
      <Route path="/client-portal/session-prepare/:sessionId" element={
        <Suspense fallback={<PageLoading />}>
          <SessionPrepare />
        </Suspense>
      } />
      
      <Route path="/client-portal/video-session/:sessionId" element={
        <Suspense fallback={<PageLoading />}>
          <VideoSession />
        </Suspense>
      } />
    </Routes>
  );
};

export default ClientPortalRoutes;
